<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-epigraph element-without-heading" epub:type="epigraph" id="epigraph">
<div class="text" id="epigraph-text">
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left epigraph-content">“…I think this is</p>
<p class="alignment-block-content alignment-block-content-left epigraph-content">the prettiest world—so long as you don’t mind</p>
<p class="alignment-block-content alignment-block-content-left epigraph-content">a little dying, how could there be a day in your whole life</p>
<p class="alignment-block-content alignment-block-content-left epigraph-content">that doesn’t have its splash of happiness?”</p>
<p class="alignment-block-content alignment-block-content-left epigraph-content">—Mary Oliver, “The Kingfisher”</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?2674a74e